import { appColors } from '@backrs_ui/common-ui';

import { appStrings } from '@backrs_ui/grow-ui/src/assets/appStrings';
import { CareerQuestion, CareerUserResponseSet } from '@backrs_ui/grow-ui/src/models/models';

import { Box, Typography, SxProps, Theme } from '@mui/material';

import { ResultsPill } from './ResultsPill';
import { RESULT_PAGE_TOUR_IDS } from '../tour/ResultPage.tour';
import { makeAspirationMap } from '../util/results.util';

const ASPIRATION_STRINGS = appStrings.modules.results;

type AspirationsExplanationsProps = Readonly<{
  userResponseSet: CareerUserResponseSet;
  questions: CareerQuestion[];
}>;

export const AspirationsExplanations = ({
  userResponseSet,
  questions,
}: AspirationsExplanationsProps) => {
  const aspirationMap = makeAspirationMap(userResponseSet, questions, 'WEB');

  return (
    <Box sx={aspirationsExplanationStyle} id={RESULT_PAGE_TOUR_IDS.step1}>
      <Box>
        <ResultsPill title={ASPIRATION_STRINGS.aspirationsTitle} />
        <Typography sx={aspirationsExplanationsStyle}>
          {ASPIRATION_STRINGS.aspirationsExplanation}
        </Typography>
      </Box>
      <Box sx={listContainerStyle}>
        {Object.entries(aspirationMap).map(([key, value]) => (
          <Typography key={key} variant="body1">
            {value}
          </Typography>
        ))}
      </Box>
    </Box>
  );
};

const aspirationsExplanationStyle: SxProps<Theme> = {
  backgroundColor: appColors.neutral.white,
  border: `2px solid ${appColors.neutral.black}`,
  borderRadius: '.5rem',
  paddingX: {
    xs: '1rem',
    sm: '2rem',
  },
  paddingY: '2rem',
  flexGrow: 1,
  display: 'flex',
  flexDirection: 'column',
};

const listContainerStyle: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  gap: 2,
  pt: 3,
};

const aspirationsExplanationsStyle: SxProps<Theme> = {
  fontStyle: 'italic',
  fontSize: '14px',
  lineHeight: '1.25',
  mt: 2,
};
